/* UsePageKnowledgeToggleFooter.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./UsePageKnowledgeToggleFooter.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import { Box } from '@atlaskit/primitives/compiled';
import Toggle from '@atlaskit/toggle';
import messages from './messages';
var footerStyles = {
  default: "_zulp1b66 _1e0c1txw _ca0q12x7 _19bv12x7 _u5f312x7 _n3td12x7 _uwhke4h9 _15a5nqa1 _1i53muej _4cvr1h6o"
};
var labelStyles = null;
export function UsePageKnowledgeToggleFooter(_ref) {
  var onChange = _ref.onChange,
    isChecked = _ref.isChecked;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var TOGGLE_ID = 'page-knowledge-toggle';
  return /*#__PURE__*/React.createElement(Box, {
    xcss: footerStyles.default,
    backgroundColor: "elevation.surface"
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: TOGGLE_ID,
    testId: TOGGLE_ID,
    onChange: onChange,
    isChecked: isChecked
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: TOGGLE_ID,
    className: ax(["_syaz1gjq"])
  }, formatMessage(messages.usePageKnowledgeToggleLabel)));
}